
import { Component, Vue } from 'vue-property-decorator';
import SMSRepositoryInterface, { SmsTemplateInterface } from '@/services/SMS/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { DataTableHeader } from 'vuetify';
import DeleteSmsTemplateDialog from '@/components/dialogs/sms/DeleteSmsTemplateDialog.vue'
import EditSmsTemplateDialog from '@/components/dialogs/sms/EditSmsTemplateDialog.vue';

@Component({
  inject: ['smsRepository'],
  components: {
    DeleteSmsTemplateDialog,
    EditSmsTemplateDialog
  }
})
export default class TemplateList extends Vue{
  private loading: boolean = true

  private headers: DataTableHeader[] = [
    { text: 'Type', value: 'type' },
    { text: 'Name', value: 'name' },
    { text: 'Message', value: 'predefinedMessage' },
    { text: 'From', value: 'senderName'},
    { text: 'Actions', value: 'actions', sortable: false },
  ]

  public templates: SmsTemplateInterface[] = []
  private deleteSmsTemplateDialogData: SmsTemplateInterface | false = false
  private deleteSmsTemplateDialog: string = ''


  private editSmsTemplateDialogData: SmsTemplateInterface | false = false;
  private editSmsTemplateDialog: string = ''

  private readonly smsRepository: SMSRepositoryInterface;

  private async mounted(): Promise<void> {
    await this.initialize()
    this.loading = false
  }
  private async initialize(): Promise<void> {
    console.log('we init')
    this.templates = await this.getAllTemplates()
  }


  private async getAllTemplates(): Promise<SmsTemplateInterface[]> {
    try {
      return await this.smsRepository.getAllTemplates()
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve templates: ' +  e.message);
      return []
    }
  }

  private createTemplate(): void {
    this.$router.push({ name: 'template_add' })
  }

  private async editZone(sms: SmsTemplateInterface): Promise<void> {
    this.editSmsTemplateDialog = 'edit-sms-template-dialog'
    this.editSmsTemplateDialogData = sms;
  }

  private async deleteZonePrompt(sms: SmsTemplateInterface): Promise<void> {
    this.deleteSmsTemplateDialog = 'delete-sms-template-dialog'
    this.deleteSmsTemplateDialogData = sms
  }

  private async deleteZone(template: SmsTemplateInterface): Promise<void> {
    try {
      await this.smsRepository.deleteTemplateByName(template.name)
      this.$successDialog.show(`Template ${template.name} has been removed.`)
      this.templates = await this.getAllTemplates()
    } catch (e) {
      this.$errorDialog.show('Error deleting template: ' +  e.message);
    }
  }

  public async updateTemplate(id:number,template: Omit<SmsTemplateInterface,"id">): Promise<void> {
    try {
      await this.smsRepository.updateTemplate(id,template)
      this.$successDialog.show(`Template ${template.name} has been updated.`)
      this.templates = await this.getAllTemplates()
    } catch (e) {
      this.$errorDialog.show('Error updating template: ' +  e.message);
    }
    console.log(template)
  }
}
